import Collapse from "@material-ui/core/Collapse";
import CloseIcon from "@material-ui/icons/Close";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import React, { FunctionComponent } from "react";
import translate from "../../../i18n/translate";
import { IDisplayNotification } from "../../../interfaces";
import "./NotificationView.scss";

interface IProps {
    displayNotification: IDisplayNotification;
    status: boolean;
    handleToggle: any;
    targetType: string
}

const NotificationView: FunctionComponent<IProps> = ({
    displayNotification,
    status,
    handleToggle,
    targetType
}: IProps) => {
    const { message, type, link } = displayNotification;
    const [open, setOpen] = React.useState(true);
    return (
        <div className="notification-container">
            <Collapse in={open}>
                <div className="notificationWrapper">
                    <Alert icon={false}

                        action={
                            <CloseIcon onClick={() => {
                                handleToggle(false, false, 0);

                            }} fontSize="inherit" />
                        }
                        className="notification-alert"
                    >
                        <div className="notification-message">
                            <AlertTitle className="notification-title">{type.includes('twt') ? translate('twt_talk_with_teacher_title') : type}</AlertTitle>
                            {(type.includes("Survey") || type.includes('twt')) ? (
                                <a className="notification-description"
                                    style={{ textDecoration: "none", color: "#FDFDFD" }}
                                    href={link}
                                    target={targetType}
                                >{message}
                                </a>
                            ) : (
                                    <p className="notification-description">{message}</p>
                                )}
                        </div>

                    </Alert>
                </div>
            </Collapse>
        </div>
    );
};

export default NotificationView;
